import React from "react";
import { Header } from "./PublicLayout";
import MobileBottomNav from "../components/MobileBottomNav";

/* ============================================================================
   PUBLIC MAP LAYOUT
   Immersive full-screen shell for the Arena map / registry experience.
   - Canonical fixed header at the top
   - Full-height workspace filling the remaining viewport
   - No traditional page footer
   - Canonical mobile bottom navigation
   ============================================================================ */

const PublicMapLayout = ({ children }) => {
  return (
    <div
      style={{
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Header />
      <div id="main-content" style={{ flex: 1, minHeight: 0, position: 'relative' }}>
        {children}
      </div>
      <MobileBottomNav />
    </div>
  );
};

export default PublicMapLayout;
